import { render, staticRenderFns } from "./Classification.vue?vue&type=template&id=079fd6b5&scoped=true&"
import script from "./Classification.vue?vue&type=script&lang=ts&"
export * from "./Classification.vue?vue&type=script&lang=ts&"
import style0 from "./Classification.vue?vue&type=style&index=0&id=079fd6b5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "079fd6b5",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('079fd6b5')) {
      api.createRecord('079fd6b5', component.options)
    } else {
      api.reload('079fd6b5', component.options)
    }
    module.hot.accept("./Classification.vue?vue&type=template&id=079fd6b5&scoped=true&", function () {
      api.rerender('079fd6b5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/streets/Classification.vue"
export default component.exports